import { render } from "./WebMenuLogotype.vue?vue&type=template&id=1e6088d0"
import script from "./WebMenuLogotype.vue?vue&type=script&lang=js"
export * from "./WebMenuLogotype.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__